import { get } from 'lodash';

import SlotSubscriptionEligibility from 'apps/topNavigation/models/SlotSubscriptionEligibility';

export function orManagementLink(user, hasProblemOrders) {
  const isRavenOrManagementEnabled = user && user.betaFeatures && user.betaFeatures.includes('OR_MANAGEMENT_RAVEN');
  const oldManagementLink = hasProblemOrders ? '/webshop/resolveProblemOrders.do' : '/webshop/displaySlotSubSetting.do';
  return isRavenOrManagementEnabled ? '/or-management' : oldManagementLink;
}

export function orLink(user) {
  switch (get(user, 'eligibilityDetails.slotSubscription')) {
    case SlotSubscriptionEligibility.ELIGIBLE_NOT_SUBSCRIBED:
      return '/or-signup';
    case SlotSubscriptionEligibility.HAS_SUBSCRIPTION:
      return orManagementLink(user, false);
    case SlotSubscriptionEligibility.NOT_ELIGIBLE:
    default:
      return '';
  }
}
